'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, createContext, useContext, ReactNode } from 'react';
import { Course } from '@udemy-v2/browse-course';
import { setRefIdToLocalStorage, getRefIdFromLocalStorage } from '@udemy-v2/utils';
import { generateTrackingId } from '@udemy-v2/event-tracking';
import { useEnrolledInCourse } from '@/features/course-landing-page/hooks/use-enrolled-in-course';
import { ClpCourse } from '@/types/course';
export type TrackedCourse = ClpCourse & {
  isDirectLanded?: boolean;
  frontendTrackingId?: string;
};
const CourseContext = createContext<TrackedCourse | null>(null);
interface CourseProviderProps {
  children: ReactNode;
  course: Course;
}

/**
 * Provider component that fetches and provides course data to its children
 */
export const ClpCourseProvider: React.FC<CourseProviderProps> = t0 => {
  const $ = _c(12);
  const {
    children,
    course
  } = t0;
  const isEnrolledInCourse = useEnrolledInCourse(course.id);
  let isDirectLandedLocal = true;
  if (typeof window !== "undefined" && document.referrer) {
    try {
      if (new URL(document.referrer).host === location.host) {
        isDirectLandedLocal = false;
      }
    } catch {}
  }
  const isDirectLanded = isDirectLandedLocal;
  let t1;
  bb0: {
    if (typeof window === "undefined") {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = generateTrackingId();
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    const t2 = Number(course.id);
    let t3;
    if ($[1] !== t2) {
      t3 = getRefIdFromLocalStorage(t2);
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    const existingRefId = t3;
    if (existingRefId) {
      t1 = existingRefId;
      break bb0;
    }
    let newRefId;
    if ($[3] !== course.id) {
      newRefId = generateTrackingId();
      setRefIdToLocalStorage(Number(course.id), newRefId);
      $[3] = course.id;
      $[4] = newRefId;
    } else {
      newRefId = $[4];
    }
    t1 = newRefId;
  }
  const courseTrackingId = t1;
  let t2;
  if ($[5] !== course || $[6] !== courseTrackingId || $[7] !== isEnrolledInCourse) {
    t2 = {
      ...course,
      isEnrolled: isEnrolledInCourse,
      frontendTrackingId: courseTrackingId,
      isDirectLanded
    };
    $[5] = course;
    $[6] = courseTrackingId;
    $[7] = isEnrolledInCourse;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== t2) {
    t3 = <CourseContext.Provider value={t2}>{children}</CourseContext.Provider>;
    $[9] = children;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};

/**
 * Hook to access the course context
 * @returns The course data
 * @throws Error if used outside of a CourseProvider
 */
export const useClpCourse = () => {
  const context = useContext(CourseContext);
  if (context === null) {
    throw new Error("useCourse must be used within a ClpCourseProvider");
  }
  return context;
};